document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),

    init() {
      if (localStorage.getItem('list-layout') == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
    },

    _getTeleportTemplate(root = document) {
      return root.querySelector('template[x-teleport="#header-filter"]');
    },

    _getRenderedDesktopForm() {
      return document.querySelector('#header-filter .form-aside') || document.querySelector('.form-aside');
    },

    _getFormAside(root = document) {
      if (root === document) {
        return this._getRenderedDesktopForm();
      }

      const directForm =
        root.querySelector('#header-filter .form-aside') ||
        root.querySelector('.form-aside');

      if (directForm) return directForm;

      const teleportTemplate = this._getTeleportTemplate(root);
      if (teleportTemplate && teleportTemplate.content) {
        return teleportTemplate.content.querySelector('.form-aside');
      }

      return null;
    },

    _getActiveForm() {
      return (
        document.getElementById('FacetFiltersForm') ||
        (this.isDesktop ? this._getRenderedDesktopForm() : document.querySelector('.form-drawer'))
      );
    },

    _ensureFacetFormIds() {
      const desktopForm = this._getRenderedDesktopForm();
      const drawerForm = document.querySelector('.form-drawer');

      if (window.innerWidth > 767) {
        this.isDesktop = true;

        if (desktopForm) {
          desktopForm.setAttribute('id', 'FacetFiltersForm');
        }

        if (drawerForm) {
          drawerForm.removeAttribute('id');
        }
      } else {
        this.isDesktop = false;

        if (desktopForm) {
          desktopForm.removeAttribute('id');
        }

        if (drawerForm) {
          drawerForm.setAttribute('id', 'FacetFiltersForm');
        }
      }
    },

    _initLayout() {
      this.$nextTick(() => {
        this._ensureFacetFormIds();

        setTimeout(() => {
          this._ensureFacetFormIds();
          this.setFilterHeaderHeight();
        }, 0);
      });
    },

    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      };

      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', () => {
        this._initLayout();
      });
    },

    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem('list-layout', theBoolean ? 'list' : 'grid');
      window.dispatchEvent(new Event('resize'));
    },

    removeFilter(url) {
      this._reloadFilter(url);
    },

    renderPagination() {
      var formData = {
        attributes: {
          'collection-pagination': this.$el.value
        }
      };

      fetch(Shopify.routes.root + 'cart/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const form = this._getActiveForm();
        if (!form) return;

        const searchParams = this._createSearchParams(form);
        this._renderPage(searchParams);
      });
    },

    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        this._ensureFacetFormIds();

        const form = this._getActiveForm();
        if (!form) return;

        const searchParams = this._createSearchParams(form);
        this._renderPage(searchParams);

        if (this.isDesktop) {
          document.getElementById('FormSelectFilter')?.blur();
        }
      };

      this.t = setTimeout(() => {
        func();
      }, wait);
    },

    rangePrice(el) {
      const rangeInput = el.querySelectorAll('.range-input input'),
        priceInput = el.querySelectorAll('.price-input'),
        pricePreview = el.querySelectorAll('.price-preview'),
        range = el.querySelector('.slider .progress');
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener('input', (e) => {
          e.preventDefault();
          let minVal = Number(rangeInput[0].value).toFixed(2),
            maxVal = Number(rangeInput[1].value).toFixed(2);

          if (maxVal - minVal < priceGap) {
            if (e.target.className === 'range-min') {
              rangeInput[0].value = maxVal - priceGap;
              priceInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
              priceInput[1].value = maxVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          pricePreview[0].textContent = minVal;
          pricePreview[1].textContent = maxVal;
        });
      });
    },

    initRange(el) {
      const rangeInput = el.querySelectorAll('.range-input input'),
        range = el.querySelector('.slider .progress');

      let minVal = Number(rangeInput[0].value).toFixed(2),
        maxVal = Number(rangeInput[1].value).toFixed(2);

      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },

    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },

    _createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },

    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },

    _renderPage(searchParams, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      this.loading = true;

      if (this.cachedResults[searchParams]) {
        this._renderResults(this.cachedResults[searchParams]);
        return;
      }

      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          this.cachedResults[searchParams] = html;
          this._renderResults(html);
        });

      if (updateURLHash) this._updateURLHash(searchParams);
    },

    _renderResults(html) {
      this._renderFilters(html);
      this._renderProductGridContainer(html);
      this._renderProductCount(html);
      this.loading = false;

      this.$nextTick(() => {
        this._initLayout();
      });
    },

    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      const currentFormDrawer = document.querySelector('.form-drawer');
      const newFormDrawer = parsedHTML.querySelector('.form-drawer');

      const currentFormAside = this._getRenderedDesktopForm();
      const newFormAside = this._getFormAside(parsedHTML);

      const activeTag = document.getElementById('active-filter-tag');
      const newActiveTag = parsedHTML.getElementById('active-filter-tag');

      if (activeTag && newActiveTag) {
        activeTag.innerHTML = newActiveTag.innerHTML;
      }

      if (currentFormDrawer && newFormDrawer) {
        if (this.$el.id) {
          const openingEl = parsedHTML.getElementById(this.$el.id)
            ? parsedHTML.getElementById(this.$el.id).closest('.js-filter')
            : undefined;

          if (openingEl) {
            openingEl.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = openingEl.innerHTML;
          }
        }

        currentFormDrawer.innerHTML = newFormDrawer.innerHTML;
        this._renderAdditionalElements(parsedHTML);
      }

      if (currentFormAside && newFormAside) {
        if (this.$el.id) {
          const openingEl = parsedHTML.getElementById(this.$el.id)
            ? parsedHTML.getElementById(this.$el.id).closest('.js-filter')
            : undefined;

          if (openingEl) {
            openingEl.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = openingEl.innerHTML;
          }
        }

        currentFormAside.innerHTML = newFormAside.innerHTML;
        this._renderAdditionalElements(parsedHTML);
      }

      const formMobile = parsedHTML.querySelector('.form-mobile');
      const currentFormMobile = document.querySelector('.form-mobile');
      if (formMobile && currentFormMobile) {
        currentFormMobile.innerHTML = formMobile.innerHTML;
      }

      this._renderAdvancedFilters(parsedHTML);

      this.$nextTick(() => {
        this._ensureFacetFormIds();
      });
    },

    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll('.filter-advanced');
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        });
      }
    },

    _renderProductGridContainer(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const newContainer = parsedHTML.getElementById('ProductGridContainer');
      const currentContainer = document.getElementById('ProductGridContainer');

      if (newContainer && currentContainer) {
        currentContainer.innerHTML = newContainer.innerHTML;
      }
    },

    _renderProductCount(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const productCountEl =
        parsedHTML.getElementById('ProductCount_source') ||
        parsedHTML.getElementById('ProductCount');

      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const mobileContainer = document.getElementById('ProductCount_header_mobile');
        const containerDrawer = document.getElementById('ProductCountDrawer');

        if (container) {
          container.innerHTML = count;
          container.classList.remove('loading');
        }

        if (mobileContainer) {
          mobileContainer.innerHTML = count;
          mobileContainer.classList.remove('loading');
        }

        if (containerDrawer) {
          containerDrawer.innerHTML = count;
        }
      }
    },

    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      const newContainer = html.getElementById('ProductPerPage');

      if (container && newContainer) {
        container.innerHTML = newContainer.innerHTML;
      }
    },

    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter', 'CloseFilter');
    },

    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },

    setFilterHeaderHeight() {
      const el = document.getElementById('FacetsWrapperDesktop');
      if (!el) return;
      document.documentElement.style.setProperty('--height-sticky-filter', el.offsetHeight + 'px');
    },

    setPositionOptionFilter(el) {
      const elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing + 'px';
      }
    },

    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if (popupRect.right > window.innerWidth) {
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});